var _excluded = ["labelPosition", "look"];
var _templateObject;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import classnames from 'classnames';
import React, { forwardRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import { BrandfolderHexColors } from "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import { InputLabelPositions, InputLooks } from "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import { boxShadowDialogs } from "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import { borderRadiusMedium } from "../../../../themes/borders.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyMedium, fontFamilyBook } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import { baseInputStyle, getInputPadding, getInputBorderRadius, getInputTheme } from "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import { screenReaderOnly } from "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { BaseDatePicker } from "../base-date-picker/base-date-picker.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var UnstyledStandardDatePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(BaseDatePicker, _extends({}, props, {
    className: classnames(_defineProperty({
      'bf-date-picker__standard': true
    }, "".concat(props === null || props === void 0 ? void 0 : props.className), !!(props !== null && props !== void 0 && props.className))),
    ref: ref
  }));
});
var StyledStandardDatePicker = styled(UnstyledStandardDatePicker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .bf-date-picker__input-wrapper {\n    position: relative;\n  }\n\n  .bf-date-picker__textfield {\n    ", "\n    ", "\n    ", "\n    ", "\n\n    .bf-textfield__textfield {\n      padding-right: 40px;\n    }\n  }\n\n  /* internal error */\n  &.bf-date-picker--error {\n    .bf-date-picker__textfield {\n      ", "\n    }\n  }\n\n  .bf-date-picker__calendar-icon-button {\n    bottom: 9px;\n    min-height: 0;\n    padding: 8px;\n    position: absolute;\n    right: 9px;\n  }\n\n  .bf-date-picker__dialog {\n    background-color: ", ";\n    ", "\n    border-radius: ", "px;\n    padding: 16px;\n    width: 256px;\n    z-index: 1;\n  }\n\n  .bf-date-picker__header {\n    align-items: center;\n    display: flex;\n    margin-bottom: 12px;\n  }\n\n  .bf-date-picker__header-button {\n    height: 20px;\n    min-height: 0;\n    padding: 0;\n    width: 20px;\n\n    .bf-button__close-icon,\n    .bf-button__font-icon {\n      font-size: 11px;\n    }\n  }\n\n  .bf-date-picker__previous-month-button {\n    margin-left: auto;\n  }\n\n  .bf-date-picker__next-month-button {\n    margin-left: 8px;\n\n    .bf-button__font-icon {\n      margin-left: 3px;\n    }\n  }\n\n  .bf-date-picker__heading {\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 22px;\n  }\n\n  .bf-date-picker__close-button {\n    margin-left: 8px;\n\n    &.bf-date-picker__close-button--hidden {\n      ", "\n    }\n  }\n\n  .bf-date-picker__grid {\n    border-collapse: collapse;\n    width: 100%;\n  }\n\n  .bf-date-picker__columnheader,\n  .bf-date-picker__grid-cell {\n    text-align: center;\n    width: 32px;\n  }\n\n  .bf-date-picker__columnheader {\n    color: ", ";\n    font-family: ", ";\n    font-size: 12px;\n    font-weight: 400;\n    height: 24px;\n    line-height: 18px;\n  }\n\n  .bf-date-picker__today {\n    background-color: ", ";\n    border-radius: 50%;\n    bottom: 3px;\n    height: 4px;\n    left: calc(50% - 2px);\n    position: absolute;\n    width: 4px;\n\n    [aria-selected='true']& {\n      background-color: ", ";\n    }\n  }\n\n  .bf-date-picker__grid-cell {\n    background-color: ", ";\n    border-radius: ", "px;\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-weight: 400;\n    height: 32px;\n    line-height: 22px;\n    outline: 0;\n    position: relative;\n\n    &:hover:not(:empty),\n    &[tabindex='0'] {\n      background-color: ", ";\n      cursor: pointer;\n    }\n\n    &[aria-disabled='true'],\n    &[aria-disabled='true']:hover {\n      background-color: ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n\n    &[aria-selected='true'],\n    &[aria-selected='true']:hover {\n      background-color: ", ";\n      color: ", ";\n      cursor: default;\n    }\n\n    &[aria-selected='true'] {\n      .bf-date-picker__today {\n        background-color: ", ";\n      }\n    }\n  }\n"])), baseInputStyle, function () {
  return getInputPadding({});
}, function () {
  return getInputBorderRadius({});
}, function (_ref) {
  var error = _ref.error,
    look = _ref.look;
  return getInputTheme({
    error: error,
    look: look
  });
}, function (_ref2) {
  var look = _ref2.look;
  return getInputTheme({
    error: 'internal',
    look: look
  });
}, BrandfolderHexColors.White, boxShadowDialogs, borderRadiusMedium, BrandfolderHexColors.Text, fontFamilyMedium, screenReaderOnly, BrandfolderHexColors.GrayDark, fontFamilyBook, BrandfolderHexColors.PurplePopsicle, BrandfolderHexColors.White, BrandfolderHexColors.White, borderRadiusMedium, BrandfolderHexColors.Text, fontFamilyBook, BrandfolderHexColors.DirtyMarshmallow, BrandfolderHexColors.White, BrandfolderHexColors.GrayMediumDark, BrandfolderHexColors.PurplePopsicle, BrandfolderHexColors.White, BrandfolderHexColors.White);
/**
 * A date picker component that allows a user to enter a date via a text field, or select a date from a calendar.
 *
 * Required props include `id`, `labels`, and `onSelection`.
 *
 * To disallow selecting dates in the past, pass `allowPastDates={false}` prop.
 * Note that `defaultSelectedDate` will be respected even when `allowPastDates` is `false` for things like due dates.
 *
 * Setting `disabled` to `true` will disable the input and the calendar button.
 * Setting `readOnly` to true will set the input to `readOnly` and disable the calendar button.
 *
 * `showCloseButton` and `showLabel` both default to `false`, but will still be accessible by screen readers.
 *
 * https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/examples/datepicker-dialog/
 *
 * @param props StandardDatePickerProps
 * @returns FunctionComponent<StandardDatePickerProps>
 */
var StandardDatePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? InputLabelPositions.Top : _props$labelPosition,
    _props$look = props.look,
    look = _props$look === void 0 ? InputLooks.Default : _props$look,
    otherProps = _objectWithoutProperties(props, _excluded);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(StyledStandardDatePicker, _extends({}, otherProps, {
    labelPosition: labelPosition,
    look: look,
    ref: ref
  })));
});
export { StandardDatePicker, UnstyledStandardDatePicker };